import React from 'react'
import AppDialog from '@/Components/AppDialog/AppDialog'

import QueryBuilderEditor from '@/feature/admin/QueryBuilder/QueryBuilderEditor'
export default class DossierQueryModal extends React.PureComponent {
    constructor(props) {
        super(props)
    }

    render() {
        const kedo = this.props.kedo
        const title =
            this.props.id > 0 ? kedo.t('Edit query') : kedo.t('Add query')

        return (
            <AppDialog
                maxWidth="xl"
                fullWidth
                open={true}
                onClose={this.props.onClose}
                headerClose={this.props.onClose}
                topAlign
                title={title}
                aria-labelledby="block-form-title"
            >
                <QueryBuilderEditor
                    id={this.props.id}
                    onSuccess={this.props.onSuccess}
                    onClose={this.props.onClose}
                    ddId={this.props.ddId}
                    kedo={kedo}
                />
            </AppDialog>
        )
    }
}
